module.exports = __webpack_public_path__ + "static/media/close_color.fbe46df7.png";